/*
 * File: loading-bar.ts
 * File Created: 2024-09-13 09:29:09
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-15 09:51:21
 * Modified By: Val Liu
 * -----
 */

import { BaseComponent, VariantType, Variants } from "@root/components/base-classes";
import { Retrier } from "@root/core/utilities/retrier";
import { Component, Prop, Watch } from "vue-property-decorator";

/// used only when debugging. default: false
const DEBUG_ALWAYS_SHOWN = false;

@Component
export default class LoadingBar extends BaseComponent {
    @Prop({
        type: [Boolean, Number],
        required: false,
        default: () => (this as unknown as LoadingBar)?.innateLoading,
    })
    loading!: boolean | number;

    /// synchronize change, delay handle loading
    loadingPercentage: number = 0;
    innateLoading: boolean = false;
    @Watch("loading", { immediate: true })
    onLoadingUpdated(newValue: boolean | number) {
        if (typeof newValue === "number") {
            this.loadingPercentage = newValue;
            if (this.innateLoading == true && newValue >= 100)
                this.loadingFalseSetter.start();
            if (this.innateLoading == false) this.innateLoading = true;
            return;
        }

        this.$nextTick(() => {
            if (newValue == true) {
                this.innateLoading = newValue;
                this.loadingPercentage = 0;
                this.loadingPercentageSetter.start();
                this.loadingFalseSetter.stop();
            } else {
                this.loadingPercentage = 100;
                this.loadingFalseSetter.start();
            }
        });
    }

    /// lifecycle hooks
    private loadingPercentageSetter!: Retrier;
    private loadingFalseSetter!: Retrier;
    created() {
        this.loadingPercentageSetter = new Retrier(() => {
            this.loadingPercentage =
                this.loadingPercentage + (100 - this.loadingPercentage) * 0.035;
        }, 30);
        this.loadingFalseSetter = new Retrier(() => {
            if (!DEBUG_ALWAYS_SHOWN) this.innateLoading = false;
            this.loadingPercentageSetter.stop();
            this.loadingFalseSetter.stop();
        }, 500);
    }
}
